import { ResolveFn } from '@angular/router';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs';
import { User } from '../models/user';
import { inject } from '@angular/core';

export const userResolver: ResolveFn<Observable<User>> = () => {
  const userService = inject(UserService);

  return userService
    .getCurrentUser();
};
